import { withInstall } from '@zoryn/utils'
import Chat from './src/chat.vue'
import Knowledge from './src/knowledge.vue'
import Share from './src/share.vue'
import SidePanel from './src/side-panel.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZAiChat: SFCWithInstall<typeof Chat> = withInstall(Chat)
export const ZAiKnowledge: SFCWithInstall<typeof Knowledge> =
  withInstall(Knowledge)
export const ZAiShare: SFCWithInstall<typeof Share> = withInstall(Share)
export const ZAiSidePanel: SFCWithInstall<typeof SidePanel> =
  withInstall(SidePanel)

export default ZAiChat

export * from './src/catalog'
export * from './src/client'
export * from './src/setup'
export * from './src/types'
export {
  consumePendingNewChat,
  registerNewChatHandler,
  useAiChatNav,
} from './src/composables/use-ai-chat-nav'
export type { HistoryGroup } from './src/composables/use-ai-chat-nav'
